import { render, staticRenderFns } from "./MainPage.vue?vue&type=template&id=6eb92691&scoped=true"
import script from "./MainPage.vue?vue&type=script&lang=js"
export * from "./MainPage.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=6eb92691&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb92691",
  null
  
)

export default component.exports